import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-icescore',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './icescore.component.html',
  styleUrl: './icescore.component.scss'
})
export class IcescoreComponent {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() userId: string = "";
  @Input() fieldKey: string = "";
  @Input() contentKey: string = "";
  @Input() aggregatedContent: string = "";
  @Input() fullWidth: boolean = true;
  isMultichoice: boolean = false;
  @Input() content = "";
  selected: number = 0;
  label: string = "";
 // obj: { "label": string, "impact": number, "ease": number, "confidence": number, "effort": number, "score": number }[] = [];
  items: { "label": string, "impact": number, "ease": number, "confidence": number, "score": number }[] = [];
  @Output() valueChange = new EventEmitter<{ "content": string, "fieldKey": string }>();
  showOptions = false;
  options: { "label": string, "selected": boolean }[] = [];
  editedLabel = -1;
  editedImpact = -1;
  editedConfidence = -1;
  editedEase = -1;

  @ViewChild('icescore', { static: true }) icescore!: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
    if (this.content != "") {
      this.convertToObject()
    }
  }

  convertToObject() {
    this.items = JSON.parse(this.content)
  }

  convertToJson() {
    this.content = JSON.stringify(this.items);
    this.valueChange.emit({ "content": this.content, "fieldKey": this.fieldKey });
  }

  enterLabel(i: number) {
    this.editedLabel = i
    this.editedImpact = -1
    this.editedConfidence = -1
    this.editedEase = -1
  }

  updateLabel(i: number) {
    this.editedLabel = -1
    this.editedImpact = -1
    this.editedConfidence = -1
    this.editedEase = -1
    this.convertToJson()
  }

  enterImpact(i: number) {
    this.editedImpact = i
    this.editedLabel = -1
    this.editedConfidence = -1
    this.editedEase = -1
  }

  updateImpact(i: number) { 
    this.editedImpact = -1
    this.editedLabel = -1
    this.editedConfidence = -1
    this.editedEase = -1
    if (this.items[i].impact < 0) {
      this.items[i].impact = 0
    }
    if (this.items[i].impact > 10) {
      this.items[i].impact = 10
    }
    this.updateScore(i)
  }

  enterConfidence(i: number) {
    this.editedConfidence = i
    this.editedLabel = -1
    this.editedImpact = -1
    this.editedEase = -1
  }

  updateConfidence(i: number) {
    this.editedConfidence = -1
    this.editedLabel = -1
    this.editedImpact = -1
    this.editedEase = -1
    if (this.items[i].confidence < 0) {
      this.items[i].confidence = 0
    }
    if (this.items[i].confidence > 10) {
      this.items[i].confidence = 10
    }
    this.updateScore(i)
  }

  enterEase(i: number) {
    this.editedEase = i
    this.editedLabel = -1
    this.editedImpact = -1
    this.editedConfidence = -1
  }

  updateEase(i: number) {
    this.editedEase = -1
    this.editedLabel = -1
    this.editedImpact = -1
    this.editedConfidence = -1
    if (this.items[i].ease < 0) {
      this.items[i].ease = 0
    }
    if (this.items[i].ease > 10) {
      this.items[i].ease = 10
    }
    this.updateScore(i)
  }

  updateScore(i: number) {
    this.items[i].score = this.items[i].impact * this.items[i].confidence * this.items[i].ease
    this.convertToJson()
  }

  addItem() {
    this.items.push({ label: "New item", impact: 0, ease: 0, confidence: 0, score: 0 })
    this.convertToJson()
  }

  deleteItem(i: number) {
    this.items.splice(i, 1)
    this.convertToJson()
  }
}
